import { createReducer, on } from "@ngrx/store"
import { CurrencyExchange } from "src/app/shared/models/database-models/CurrencyExchange.model"
import { addCurrencyExchange } from "./CurrencyExchange.action"

const initialState: CurrencyExchange[] = []

export const currencyReducer = createReducer(initialState,
    on(addCurrencyExchange, (state, { currency }) => {
        if (!state.find(x => x.Value == currency.Value))
            return [...state, currency]
        else return state
    })
)
